import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../../components/homeComponents/Footer";
import classes from "./DataView.module.css";
import loadingSpinner from "../../assets/gifs/loading-spinner.gif";
import svgBack from "../../assets/SVGs/back.svg";
import ExcelData from "../../components/mainComponents/ExcelData";
import refreshToken from "../../functions/refreshToken";
import noAccess from "../../assets/images/Home/noAccess.png";
import * as XLSX from "xlsx";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import toast from "react-hot-toast";

function DataView() {
  const [picLoaded, setPicLoaded] = useState(false);
  const [textLoaded, setTextLoaded] = useState(false);
  const [image, setImage] = useState(null);
  const [title, setTitle] = useState([]);
  const [contentBody, setContentBody] = useState([]);
  const [showNavigation, setShowNavigation] = useState(false);
  const token = localStorage.getItem("token");
  const location = useLocation();
  const navigate = useNavigate();
  const filepath = location.state.files || [];

  let imageAddress = "";
  let excelAddress = "";

  filepath.forEach((file) => {
    if (file.name.endsWith(".xlsx")) {
      excelAddress = file.download_url;
    } else if (file.name.endsWith(".jpg") || file.name.endsWith(".png")) {
      imageAddress = file.download_url;
    }
  });

  const fullImageAddress = imageAddress;
  const fullExcelAddress = excelAddress;
  const pathToHere = filepath.length > 0 ? filepath[0].path : "";

  useEffect(() => {
    if (fullImageAddress && !picLoaded) {
      getPic();
    }
  }, [fullImageAddress, picLoaded]);

  useEffect(() => {
    if (fullExcelAddress && !textLoaded) {
      getTextData();
    }
  }, [fullExcelAddress, textLoaded]);

  function getPic() {
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${token}`);
    fetch(fullImageAddress, { headers })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.blob();
      })
      .then((blob) => {
        const imageUrl = URL.createObjectURL(blob);
        setImage(imageUrl);
        setShowNavigation(true);
        setPicLoaded(true);
      })
      .catch((error) => {
        setImage(noAccess);
        refreshToken(getPic); // Retry fetching the image
      });
  }

  function getTextData() {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(fullExcelAddress, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.blob(); // Use response.blob() for binary data
      })
      .then((blob) => {
        // Assuming you are using a library to parse Excel, such as 'xlsx'
        // Modify this part to fit how you handle Excel data
        var reader = new FileReader();
        reader.onload = function (event) {
          var data = new Uint8Array(event.target.result);
          var workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          setTitle(jsonData.map((row) => row[0]));
          setContentBody(jsonData.map((row) => row[1]));
          setTextLoaded(true);
        };
        reader.readAsArrayBuffer(blob);
      })
      .catch((error) => {
        setTitle(["عدم دسترسی به محتوا"]);
        setContentBody(["شما به این محتوا دسترسی ندارید"]);
        toast.error("شما به این محتوا دسترسی ندارید");
      });
  }
  var runonce = false;
  window.onpopstate = () => {
    if (!runonce) {
      navigate(-1);
      runonce = true;
    }
  };
  return (
    <div className={classes.main}>
      <div className={classes.header}>
        {showNavigation && (
          <div className={classes.return} onClick={() => navigate(-1)}>
            <img src={svgBack} className={classes.svg} alt="Back" />
          </div>
        )}

        <div className={classes.route}>{pathToHere}</div>
      </div>
      <div className={classes.body}>
        <div className={classes.img_Container}>
          {picLoaded ? (
            <TransformWrapper>
              <TransformComponent>
                <img
                  id="image"
                  className={classes.img_body}
                  src={image}
                  alt="Preview"
                />
              </TransformComponent>
            </TransformWrapper>
          ) : (
            <div className={classes.loader}>
              {/* <img src={loadingSpinner} alt="Loading..." /> */}
            </div>
          )}
        </div>
        {textLoaded ? (
          <ExcelData title={title} body={contentBody} />
        ) : (
          <div className={classes.loadingText}>
            در حال دریافت داده ها از سرور ... لطفا منتظر بمانید
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default DataView;
